var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Preload'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isTopShow),expression:"isTopShow"}],staticClass:"back-top",on:{"click":_vm.toTop}},[_c('Icon',{staticClass:"icon-top",attrs:{"name":"top"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }